<div class="indicadores-container">
  <div class="indicadores-slide">
    <div class="indicador">💵 Dólar: {{ dolarCompra | currency:'BRL':'symbol-narrow':'1.2-2':'pt-BR' }}</div>
    <div class="indicador">🏦 Selic: {{ indicadores?.selic != null ? (indicadores.selic / 100 | percent:'1.2-2':'pt-BR')
      : 'Carregando...' }}</div>
    <div class="indicador">💰 CDI: {{ indicadores?.cdi != null ? (indicadores.cdi / 100 | percent:'1.2-2':'pt-BR') :
      'Carregando...' }} </div>
    <div class="indicador">📈 IPCA (últimos 12 meses): {{ indicadores?.ipca != null ? (indicadores.ipca / 100 |
      percent:'1.2-2':'pt-BR') : 'Carregando...' }} </div>
    <div class="indicador">📊 IGP-M (últimos 12 meses): 7,02%</div>
    <div class="indicador">🏗️ INCC (últimos 12 meses): 7,17%</div>
  </div>
</div>